@use 'src/global/variables.scss' as var;

leichte-sprache-bubble-two-column-images {
  display: block;
  width: 100%;
  height: 100%;

  section {
    display: flex;
    padding: 1rem; // Has to adapt to global font size coming from BA CSS outside this component
    box-shadow: var.$message-screen-elements-box-shadow;
    box-sizing: border-box;
    border-radius: var.$bubble-border-radius;
    background: var.$ls-bot-bubble;
    color: var.$ls-text-color-dark;

    a {
      &:link {
        color: var.$ls-link-color-unvisited;
      }

      &:visited {
        color: var.$ls-link-color-visited;
      }

      &:focus {
        outline: 3px solid var.$ls-focus-color;
        outline-offset: 2px;
        color: var.$ls-link-color-unvisited;
        &:visited {
          color: var.$ls-link-color-visited;
        }
      }

      &:hover {
        color: var.$ls-link-color-unvisited; // For IE11 and Edge, where the styles clash with BA CSS
      }

      &:active {
        color: var.$ls-link-color-unvisited;
      }
    }

    .left {
      flex-basis: 100%;
      img {
        max-width: 100%;
        max-height: 40vh;
        display: block;
      }
      @media screen and (min-width: 540px) {
        flex-basis: 60%;
        img {
          display: none;
        }
      }
    }
    .right {
      display: none;
      @media screen and (min-width: 540px) {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;
      }
      flex-basis: 40%;
      img {
        display: block;
        float: right;
        max-height: 200px;
        max-width: 100%;
        width: auto;
      }
    }
  }
}
